'use client'

import Link from 'next/link'
import { cn } from '@/dc-shared-web/src'

type NotificationContainerProps = {
  isUnread: boolean
  notificationUrl: string
  onClick: () => void
  onMouseEnter: () => void
  onMouseLeave: () => void
  children: React.ReactNode
}

/**
 * A reusable container component for notifications that handles
 * styling, hover state, and navigation
 */
export const NotificationContainer = ({
  isUnread,
  notificationUrl,
  onClick,
  onMouseEnter,
  onMouseLeave,
  children,
}: NotificationContainerProps) => {
  return (
    <Link
      className={cn(
        'tw-flex tw-items-start tw-p-3 tw-w-full tw-gap-1',
        !isUnread && 'hover:tw-bg-neutral-50',
        isUnread && 'tw-bg-primary-50 hover:tw-bg-primary-100'
      )}
      href={notificationUrl}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {children}
    </Link>
  )
}

export default NotificationContainer
